import GlobalNotifier from 'components/GlobalNotifier';

const { addNotification } = GlobalNotifier;

const error = message => addNotification({ message, level: 'error' });

export default class Notifications {
  static showGMapsFailed = () => error('Google Maps extension load failed.');
}
